import * as React from 'react';
import { Theme, useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import {useAppSelector} from "../../app/hooks";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name: string, personName: string | any[], theme: Theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}


interface MeetingProps {
    setMeetings?: any
    meetingError?: boolean,
    reset?: any
}
export default function MeetingSelector({ setMeetings, meetingError }:MeetingProps) {
    const theme = useTheme();
    const [selectedMeeting, setSelectedMeeting] = React.useState([]);
    const { meetings } = useAppSelector(state => state.meetings);

    const handleChange = (event: any) => {
        const {
            target: { value },
        } = event;

        setSelectedMeeting(
            typeof value.name === 'string' ? value.split(',') : value,
        );

        setMeetings(value);

    };

    // @ts-ignore
    return (
        <FormControl fullWidth>
            <InputLabel id={'meeting-selector'}>Meeting</InputLabel>
            <Select
                variant={"outlined"}
                    labelId="meeting-selector"
                    id="demo-multiple-chip"
                    multiple
                    fullWidth
                    label={'chip'}
                    error={meetingError}
                    value={selectedMeeting}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                // @ts-ignore
                                <Chip key={`${value.name}`} label={`${value.name}`} />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
            >
                {meetings.map((name) => (
                    // @ts-ignore
                    <MenuItem
                        key={name.name + new Date()}
                        value={name}
                        style={getStyles(name.name, selectedMeeting, theme)}
                    >
                        {name.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
